import React, { useEffect, useState } from "react";
import { HTTP } from "../../../api/resources";
import Select from "react-select";

export default function PageBlocking({pageId, allMembers, blockedMembers}) {
  const [editMembers, setEditMembers] = useState(blockedMembers);
  const [saving, setSaving] = useState(false);
  const [editing, setEditing] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [selectOptions, setSelectOptions] = useState(null);
  const [unsavedIds, setUnsavedIds] = useState([])
  const [showMembers, setShowMembers] = useState(false);
  const [totalSelection, setTotalSelection] = useState(editMembers)

  useEffect(() => {
    initializeSelectOptions()
    setUnsavedIds([])
  }, []);

  const addMember = () => {
    if (selectedMember) {
      unsavedIds.push(selectedMember.id)
      let index = _.findIndex(editMembers, {id: selectedMember.id})

      if (index < 0) {
        selectedMember.not_saved = true
        setEditMembers(state => [...state, selectedMember])
      }
    }
    setSelectedMember(null)
    removeSelectOption(selectedMember)
  }

  const removeArray = (id) => {
    if (id < 0) return undefined
    for (let i = 0; i < unsavedIds.length; i++) {
      let arrValue = unsavedIds[i]
      if (arrValue == id) {
        unsavedIds.splice(i, 1)
      }
    }
  }

  const removeMember = (member) => {
    if (window.confirm('Are you sure you want to unblock this user?'))
        removeCommunityMember(member)
    else {
    return
    }
    const updatedMembers = _.reject(editMembers, (g) => g.id == member.id);
    setEditMembers(updatedMembers)
    addSelectOption(member)
    removeArray(member.id)
    setTotalSelection(editMembers)
  }

  const removeCommunityMember = async (member) => {
    setSaving(true)
    HTTP.delete(`/community/blocked_members/${pageId}/${member.id}`).then(response => {
      setSaving(false);
      Alert.show('notice', 'User unblocked and can now be added to the group');
      setTimeout(() => {window.location.reload()}, 1000)
    }).catch(e => {
      setSaving(false);
      Alert.show('error', 'User not unblocked! Try again or refresh.');
    })
  }

  const save = () => {
    setSaving(true);
    let arr = []
    editMembers.map(m => arr.push(m.id))
    const data = { member_ids: arr }


    HTTP.patch(`/community/blocked_members/${pageId}`, data).then(response => {
        setUnsavedIds([])
        setSaving(false);
        setEditMembers(response.data);
        setTotalSelection(response.data)
        Alert.show('notice', 'Users blocked successfully');
        setTimeout(() => {window.location.reload()}, 1000)
      }).catch(e => {
        setSaving(false);
        Alert.show('error', 'Users not blocked! Try again or refresh.');
      })
  }

  const initializeSelectOptions = () => {
    let updatedOptions = _.differenceWith(allMembers, editMembers, (a, b) => a.id == b.id)
    updatedOptions = _.orderBy(updatedOptions, ['first_name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const addSelectOption = (option) => {
    let updatedOptions = [...selectOptions, option]
    updatedOptions = _.orderBy(updatedOptions, ['first_name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  const removeSelectOption = (option) => {
    let updatedOptions = _.reject(selectOptions, (a) => a.id == option.id)
    updatedOptions = _.orderBy(updatedOptions, ['first_name'], ['asc'])
    setSelectOptions(updatedOptions)
  }

  // remove unsaved from list
  const cleanList = () => {
    if (unsavedIds.length > 0) {
    for (let num = 0; unsavedIds.length > num; num++) {
      let unsaved = unsavedIds[num]
      for (let x = 0; editMembers.length > x; x++) {
        if (unsaved == editMembers[x].id) {
          editMembers.splice(x, 1)
        }
      }
    }
    }
  }

  const clearComp = () => {
    setEditing(false)
    if(unsavedIds.length > 0)  Alert.show('notice', `${unsavedIds.length} unsaved members has been removed from the list`)
    cleanList()
    setUnsavedIds([])
    initializeSelectOptions()
  }

  useEffect(() => {
    if (!showMembers && !editing) {
        setEditMembers(totalSelection.slice(0, 5))
    }

    if (showMembers || editing) {
        setEditMembers(blockedMembers)
    }
  }, [showMembers, editing])

  return(
    <div id="user-group-form" className="card">
      <div className="card-header flex-header">
        <div>
          <h4 className="card-title">Blocked Members</h4>
        </div>
        <div>
          {editing && (
            <div>
              <button onClick={clearComp} name="button" className="btn btn-outline-danger mr-1">
                Close
              </button>
              <button onClick={save} name="button" className="btn btn-primary">
                {saving && (<i className="fa fa-spinner-third fa-spin mr-2"></i>)}
                Save
              </button>
            </div>
          )}
          {!editing && !showMembers &&
            <button onClick={() => {setShowMembers(true); setEditing(false)}} className="btn btn-primary mr-1"> Show Users</button>
          }
          {!editing && showMembers &&
            <button onClick={() => setShowMembers(false)} className="btn btn-primary mr-1"> Hide Members</button>
          }
          {!editing && (
            <button onClick={() => setEditing(true)} className="btn btn-primary"> Edit Users</button>
          )}
        </div>
      </div>

      {editing && (
        <div className="form-group">
          <label>Add Members</label>
          <div className="input-group">
            <Select
              className="form-control select-Members"
              classNamePrefix="select-Members"
              onChange={(member) =>
                setSelectedMember(member)
              }
              options={selectOptions}
              getOptionLabel={member => `${member.first_name} ${member.last_name}` }
              getOptionValue={member => member.id}
              value={selectedMember}
            />
            <div className="input-group-append">
              <button onClick={() => addMember()} className="btn btn-danger">Block</button>
            </div>
          </div>
        </div>
      )}

      <div className="list-group list-group-flush">
        {editMembers.map((member) => (
          <div key={member.id} id={`group-table-${member.id}`} className="list-group-item">
            <div className='list-group-item-body'>
              <div className='list-group-item-body-main mb-2'>
                <span className="mr-1">{member.first_name} {member.last_name}</span>
              </div>
            </div>
            {editing && (<div className='list-group-item-actions d-none-mobile'>
              { member.not_saved && (<span className="badge badge-sm badge-warning badge-pill mr-2">Not Saved</span>)}

              <button
                onClick={() => removeMember(member)}
                className="btn btn-sm btn-danger">Unblock</button>
            </div>
            )}

          </div>)
        )}
      </div>
    </div>
  );
}
